<template>
  <div class="qrcode">
    <steps v-if="stepCount" :step-count="stepCount" :current-step="currentStep" />
    <weui-group :title="title">
      <weui-cell>
        <img src="https://open.weixin.qq.com/qr/code?username=gh_256a4981d572" >
      </weui-cell>
    </weui-group>
  </div>
</template>

<script>
import { WeuiGroup, WeuiCell } from '@/components/weui';
import Steps from '@/components/share/Steps';

export default {
    props: {
        title: {
            type: String,
            default: null,
        },
        stepCount: {
            type: Number,
            default: 0,
        },
        currentStep: {
            type: Number,
            default: 0,
        },
    },
    components: {
        WeuiGroup,
        WeuiCell,
        Steps,
    },
};
</script>

<style scoped>
  img {
    display: block;
    width: 92vw;
    height: 92vw;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/share/QRCode.vue